let groupPopup = {
  popupEl: null,
  url: null,

  init: function() {
    let _this = this;
    this.popupEl = document.querySelector('.group-popup--container');
    let popupClosed = getCookie('group-popup-closed');
    let popupCode = getCookie('group-popup-code');

    this.url = window.group_popup_url;
    //this.url = 'https://www.robertsshopping.com/';

    if(this.popupEl && !popupClosed) {
      this.openPopup();
    }
    if(popupCode != null) {
      this.addCodeToURL(popupCode);
    }

    if(this.popupEl) {
      this.popupEl.querySelectorAll('.close, .close-link').forEach(el => {
        el.addEventListener('click', function() {
          _this.closePopup();
        });
      });

      if(this.popupEl.querySelector('.group-popup-form') != null) {
        this.popupEl.querySelector('.group-popup-form').addEventListener('submit', function(e) {
          e.preventDefault();
          _this.submitForm();
        });
      }
    }

    if(document.querySelector('.group-code-field') != null) {
      document.querySelector('.group-code-field .submit-group-code').addEventListener('click', function(e) {
        e.preventDefault();
        _this.submitHeaderForm();
      });
    }

    if(document.querySelector('.group-code-field') != null) {
      document.querySelector('.group-code-field .submit-group-code').addEventListener('click', function(e) {
        e.preventDefault();
        _this.submitHeaderForm();
      });

      document.querySelector('.group-code-field input').onkeydown = function(e){
        if(e.key == 'Enter'){
          _this.submitHeaderForm();
        }
      };
    }
  },

  openPopup: function() {
    this.popupEl.classList.add('active');
    document.querySelector('body').classList.add('popup-open');
  },

  closePopup: function() {
    this.popupEl.classList.remove('active');
    document.querySelector('body').classList.remove('popup-open');
    setCookie('group-popup-closed', true, 1);
  },

  submitForm: function() {
    let field = this.popupEl.querySelector('input[name="group-code"]');
    let val = field.value;
    if(val.length > 0) {
      field.classList.remove('error');
      setCookie('group-popup-code', val, 1);
      setCookie('group-popup-closed', true, 1);
      this.addCodeToURL(val);
      this.closePopup();
    }
    else {
      field.classList.add('error');
    }
  },

  submitHeaderForm: function() {
    let val = document.querySelector('.group-code-field input[name="group-code"]').value;
    this.addCodeToURL(val);
  },

  submitHeaderForm: function() {
    let field = document.querySelector('.group-code-field input[name="group-code"]');
    let val = field.value;
    if(val.length > 0) {
      field.classList.remove('error');
      this.addCodeToURL(val);
    }
    else {
      field.classList.add('error');
    }
  },

  addCodeToURL: function(code) {
    if ('URLSearchParams' in window) {
      var searchParams = new URLSearchParams(window.location.search)
      searchParams.set("code", code);
      var newRelativePathQuery = this.url + '?' + searchParams.toString();
      window.location.href = newRelativePathQuery;
    }
  }

}

groupPopup.init();